<template>
  <svg width="31" height="26" viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- eslint-disable-next-line max-len -->
    <path
      d="M12.1982 5C12.1982 3.34315 13.5414 2 15.1982 2C16.8551 2 18.1982 3.34315 18.1982 5V13C18.1982 14.6569 16.8551 16 15.1982 16C13.5414 16 12.1982 14.6569 12.1982 13V5Z"
      :fill="pathFill"
    />
    <!-- eslint-disable-next-line max-len -->
    <path
      d="M16.1982 19.9291C19.5905 19.4439 22.1982 16.5265 22.1982 13C22.1982 12.4477 21.7505 12 21.1982 12C20.646 12 20.1982 12.4477 20.1982 13C20.1982 15.7614 17.9597 18 15.1982 18C12.4368 18 10.1982 15.7614 10.1982 13C10.1982 12.4477 9.75053 12 9.19824 12C8.64596 12 8.19824 12.4477 8.19824 13C8.19824 16.5265 10.8059 19.4439 14.1982 19.9291V22H11.1982C10.646 22 10.1982 22.4477 10.1982 23C10.1982 23.5523 10.646 24 11.1982 24H19.1982C19.7505 24 20.1982 23.5523 20.1982 23C20.1982 22.4477 19.7505 22 19.1982 22H16.1982V19.9291Z"
      :fill="pathFill"
    />

    <line
      x1="0.5"
      y1="5.75006"
      x2="29.0788"
      y2="22.2501"
      :stroke="lineTwoStroke"
      stroke-width="2"
      v-if="muted"
    />
  </svg>
</template>

<script>
export default {
  props: {
    muted: {
      type: Boolean,
      default: false,
    },
    pathFill: {
      type: String,
      default: '#FFFFFF',
    },
    lineOneStroke: {
      type: String,
      default: '#000000',
    },
    lineTwoStroke: {
      type: String,
      default: '#FFFFFF',
    },
  },
};
</script>
